// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v2.CappsLandlordApplicationPermissionsV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, PermissionCheckV2WebApiDto } from '../..';

interface PermissionCheckParams {
  listingAlias: ListingAlias;
}

export const CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_Path =
  '/api/web/landlord/v2/applications/permissionCheck';

export const CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck = (
  getParams: PermissionCheckParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<PermissionCheckParams, never, PermissionCheckV2WebApiDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicationPermissionsV2WebApiHandler_permissionCheck_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
